/**
 * Log content key missing errors to the server
 */

import $ from 'jquery'
import { trackMissingContent, getShortStack } from '../analytics/fpti'

// we don't support dynamic locale loading from the client, so just grab locale from the DOM
const locale = document
  .querySelector('html')
  .getAttribute('lang')
  .split('_')
  .reverse()
  .join('/') // 'en_US' => 'US/en'

// Map of missing keys and associated URLs.
const missingContentData = {}

// Boolean if we already started listening on this page or not.
let listening = false

// A list we can use to:
// 1. make sure we don't log the same missing key once per session
// 2. make sure we don't log more than 3 separate keys per session (we don't want to spam fpti)
const previousFptiLogs = []

/**
 * Write missing content key to data.
 */
export function logMissingContent({ path, content }) {
  const key = `${locale}/${path}`
  const contentSize =
    typeof content === 'object' && content !== null
      ? Object.keys(content).length
      : -1

  // need to do it this way because IE doesn't let you just get the stack from the error object
  let stack
  try {
    throw new Error()
  } catch (e) {
    stack = getShortStack({
      stack: (e.stack || '')
        .split('\n')
        .slice(3) // remove unnecessary internal pp-react-l10n calls from stack
        .join('|')
        .replace(/\s{2,}/g, ' '),
    })
  }

  missingContentData[key] = {
    key, // will make it easier to view locale in Grafana
    url: window.location.href,
    contentSize, // try logging size of content to see if it has loaded
    stack, // try logging stack to see which line called `i18n()`
  }

  // limit our calls to fpti
  const strigifiedData = JSON.stringify(missingContentData[key])
  if (
    previousFptiLogs.length < 4 &&
    !previousFptiLogs.includes(strigifiedData)
  ) {
    // if we have posted to fpti less than three times, and not posted this key yet
    previousFptiLogs.push(strigifiedData)
    trackMissingContent(missingContentData[key])
  }
}

/**
 * Start listening for window unload
 */
export function startContentErrorTracking(url) {
  // Protects from multiple event listeners.
  if (listening) {
    return
  }

  listening = true

  $(window).on('beforeunload', function() {
    try {
      // Convert map to array.
      const data = Object.keys(missingContentData).map(function(key) {
        return missingContentData[key]
      })

      // Make sure something is going to be posted.
      if (!data.length) {
        return
      }

      // Using sync jQuery ajax here for sending required CSRF header.
      $.ajax({
        type: 'POST',
        url: url,
        data: { missingContent: data },
      })
    } catch (e) {
      // Try-catch block here to make sure none of our private script
      // errors get sent to the server.
      // Do nothing here. We are currently dropping support for browsers
      // that do not support Object.keys, Array.map.
    }
  })
}
